import { IndexTable, Text } from '@shopify/polaris';

const SellStockTable = ({ product, sell }) => {
  const headings = [{ title: '' }, ...product.variants.map((v) => ({ title: v.title })), { title: 'TOTAL' }] || [];

  return (
    <IndexTable headings={headings} itemCount={2} selectable={false} lastColumnSticky={true}>
      {sell.status === 'DRAFT' && <QtyDepositOriginStockRow deposit={sell.deposit} product={product} />}
      <QtyInputStockRow product={product} />
    </IndexTable>
  );
};

export default SellStockTable;

const QtyDepositOriginStockRow = ({ deposit, product }) => {
  return (
    <IndexTable.Row subdued selected={false}>
      <IndexTable.Cell>
        <Text alignment="start" variant="headingXs" fontWeight="bold">
          {deposit.name}
        </Text>
      </IndexTable.Cell>
      {product.stock.map((s, i) => (
        <IndexTable.Cell key={i}>
          <Text alignment="center" variant="headingXs" fontWeight="regular">
            {s.originDepositExistsBefore} {s.qty > 0 ? ' -> ' + s.originDepositExistsAfter : ''}
          </Text>
        </IndexTable.Cell>
      ))}
      <IndexTable.Cell>
        <Text alignment="center" variant="headingXs" fontWeight="bold">
          {product.stock.reduce((acc, cur) => acc + cur.originDepositExistsBefore, 0)}{' '}
          {product.stock.reduce((acc, cur) => acc + cur.qty, 0)
            ? ' -> ' + product.stock.reduce((acc, cur) => acc + cur.originDepositExistsAfter, 0)
            : ''}
        </Text>
      </IndexTable.Cell>
    </IndexTable.Row>
  );
};

const QtyInputStockRow = ({ product }) => {
  return (
    <IndexTable.Row subdued selected={false}>
      <IndexTable.Cell>
        <Text alignment="start" variant="headingXs" fontWeight="bold">
          TRANSFERENCIA
        </Text>
      </IndexTable.Cell>
      {product.stock.map((s, i) => (
        <IndexTable.Cell key={i}>
          <Text alignment="center" variant="headingXs" fontWeight="regular">
            {s.qty}
          </Text>
        </IndexTable.Cell>
      ))}
      <IndexTable.Cell>
        <Text alignment="center" variant="headingXs" fontWeight="bold">
          {product.stock.reduce((acc, cur) => acc + cur.qty, 0)}
        </Text>
      </IndexTable.Cell>
    </IndexTable.Row>
  );
};
